/* global showSuccessToast */
/* global showInfoToast */
/* global showWarningToast */
/* global showDangerToast */
import React, { useState, useEffect, use } from "react";
import FooterBar from "./layout/FooterBar";
import FooterButton from './tools/FooterButton';
import { getShiftTypes, getShiftUsers, getShifts, getCompanyOffices, getShiftClosures } from "../api/api";
import { addShift, addShiftClosure } from "../api/api";
import { deleteShiftClosure } from "../api/api";
import globals from '../config/globals.json'
import Calendar from "./tools/Calendar";

const Turni = (props) => {
    const companyID = props.userDetails?.Company?.[0]?.dataID || null;
    const formatLocalDate = (date) => {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        return `${y}-${m}-${d}`;
    };

    const getShiftTimestamp = (dateString, period) => {
        const [y, m, d] = dateString.split('-').map(Number);
        return `${period}${new Date(y, m - 1, d, 9, 0, 0, 0).getTime()}`;
    };

    const [loading, setLoading] = useState(false); // <-- aggiungi stato loading
    const [selectedMonth, setSelectedMonth] = useState(() => {
        const now = new Date();
        return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`; // "YYYY-MM"
    });
    const [selectedDay, setSelectedDay] = useState(() => {
        const now = new Date();
        return now.getDate();
    });
    const [selectedDate, setSelectedDate] = useState(() => {
        const now = new Date();
        setSelectedMonth(`${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`);
        return formatLocalDate(now); // "YYYY-MM-DD"
    });

    const [timestamp, setTimeStamp] = useState(null);
    const [user, setUser] = useState(null);
    const [shiftID, setShiftID] = useState(null);
    const [shiftType, setShiftType] = useState(null);
    const [closures, setClosures] = useState([]);
    const [closuresObjects, setClosuresObjects] = useState([]);

    const [shiftUsers, setShiftUsers] = useState([]);
    const [shiftTypes, setShiftTypes] = useState([]);
    const [shifts, setShifts] = useState([]);
    const [companyOffices, setCompanyOffices] = useState([]);
    const [selectedOffice, setSelectedOffice] = useState(null);
    const [viewMode, setViewMode] = useState("week"); // "month" o "week"
    const daysOfWeek = ["Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato", "Domenica"];
    const monthsOfYear = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novemre", "Dicembre"];

    const year = parseInt(selectedMonth.split('-')[0]);
    const month = parseInt(selectedMonth.split('-')[1]) - 1;

    const getDaysInMonth = (year, month) => new Date(year, month + 1, 0).getDate();
    const daysInMonth = getDaysInMonth(year, month);

    // Genera lista giorni del mese
    const monthDays = Array.from({ length: daysInMonth }, (_, i) => {
        const date = new Date(year, month, i + 1);
        return {
            day: i + 1,
            date: formatLocalDate(date),
            dayName: daysOfWeek[date.getDay() === 0 ? 6 : date.getDay() - 1].toUpperCase()
        };
    });

    // Genera lista giorni della settimana
    const getWeekDays = (dateString) => {
        const [y, m, d] = dateString.split('-').map(Number);
        const date = new Date(y, m - 1, d);
        const dayOfWeek = date.getDay();
        const startDate = new Date(date);
        startDate.setDate(date.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1));

        return Array.from({ length: 7 }, (_, i) => {
            const weekDate = new Date(startDate);
            weekDate.setDate(startDate.getDate() + i);
            return {
                day: weekDate.getDate(),
                date: formatLocalDate(weekDate),
                dayName: daysOfWeek[i]
            };
        });
    };

    const weekDays = getWeekDays(selectedDate);

    let days = viewMode === "month" ? monthDays : weekDays;

    const fetchShiftUsers = async () => {
        const response = await getShiftUsers(companyID, selectedMonth);
        if (response) {
            setShiftUsers(response.data.data.getShiftUserListing.edges);
        }
    }

    const fetchShiftTypes = async () => {
        const response = await getShiftTypes(companyID);
        if (response) {
            setShiftTypes(response.data.data.getShiftTypeListing.edges);
        }
    }

    const fetchCompanyOffices = async () => {
        const response = await getCompanyOffices(companyID);
        if (response) {
            setCompanyOffices(response.data.data.getCompanyOfficeListing.edges);
        }
    }

    const fetchShifts = async () => {
        const response = await getShifts(companyID, selectedMonth);
        if (response) {
            setShifts(response.data.data.getShiftListing.edges);
        }
    }

    const fetchClosures = async () => {
        const response = await getShiftClosures(companyID, selectedMonth);
        if (response) {
            setClosures(response.data.data.getShiftClosureListing.edges.map(closure => closure.node.date));
            setClosuresObjects(response.data.data.getShiftClosureListing.edges);
        }
    }

    const handleOpenShiftModal = (timestamp, userID, shiftID) => {
        console.log("Opening shift modal with timestamp:", timestamp, "userID:", userID, "shiftID:", shiftID);
        setTimeStamp(timestamp);
        setUser(userID);
        setShiftID(shiftID);
        timestamp = timestamp.replace("M", "").replace("P", "");
        timestamp = parseInt(timestamp);
        const date = new Date(timestamp);
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        setSelectedDate(`${y}-${m}-${d}`); // Aggiorna selectedDate nel formato AAAA-MM-GG quando si apre il modal
    }

    const handleAddShift = async (e) => {
        const plainData = {
            timestamp: timestamp,
            User: user,
            ShiftType: shiftType,
        };

        const shiftResponse = await addShift(plainData, companyID, selectedMonth, shiftID);
        if (!shiftResponse?.data?.data?.createShift?.output?.id && !shiftResponse?.data?.data?.updateShift) {
            console.error("Errore: risposta non valida durante l'aggiunta del turno", shiftResponse);
            showDangerToast("Si è verificato un errore durante l'aggiunta del turno. Riprova.");
            return;
        }
        showSuccessToast("Turno aggiunto con successo!");

        const modal = document.getElementById('modalShiftEdit');
        window.$(modal).modal('hide');
        setShiftType(null);
        fetchShifts(); // Ricarica i turni dopo l'aggiunta
        fetchClosures(); // Ricarica le chiusure dopo l'aggiunta
    }

    const handleClosure = (day) => {
        if (props.userDetails.role > 1) {
            showWarningToast("Non hai i permessi per effettuare questa modifica.");
            return;
        }
        const isClosed = closures.includes(day.date);
        if (isClosed) {
            const closure = closuresObjects.find(closure => closure.node.date === day.date);
            deleteShiftClosure(closure.node.id, companyID, selectedMonth).then(response => {
                if (response?.data?.data?.updateShiftClosure?.success) {
                    showSuccessToast(`${day.dayName} ${day.day} riaperto!`);
                    fetchClosures(); // Ricarica le chiusure dopo l'aggiunta
                } else {
                    console.error("Errore: risposta non valida durante l'aggiornamento della chiusura", response);
                    showDangerToast("Si è verificato un errore durante la chiusura del giorno. Riprova.");
                }
            }).catch(error => {
                console.error("Errore durante la richiesta di chiusura del giorno:", error);
                showDangerToast("Si è verificato un errore durante la chiusura del giorno. Riprova.");
            });
        } else {
            addShiftClosure({ date: day.date }, companyID, selectedMonth).then(response => {
                if (response?.data?.data?.createShiftClosure?.output?.id) {
                    showInfoToast(`${day.dayName} ${day.day} chiuso!`);
                    fetchClosures(); // Ricarica le chiusure dopo l'aggiunta
                } else {
                    console.error("Errore: risposta non valida durante l'aggiunta della chiusura", response);
                    showDangerToast("Si è verificato un errore durante la chiusura del giorno. Riprova.");
                }
            }).catch(error => {
                console.error("Errore durante la richiesta di chiusura del giorno:", error);
                showDangerToast("Si è verificato un errore durante la chiusura del giorno. Riprova.");
            });
        }
    }

    useEffect(() => {
        if (shiftType) {
            handleAddShift();
        }
    }, [shiftType]);

    useEffect(() => {
        setLoading(true); // mostra loader
        if (companyID) {
            fetchCompanyOffices();
            fetchShiftUsers();
            fetchShiftTypes();
            fetchShifts();
            fetchClosures();
            setLoading(false); // nascondi loader
        }
    }, [selectedMonth, companyID]);

    useEffect(() => {
        if (selectedMonth) {
            console.log("Mese selezionato:", selectedMonth);
        }
    }, [selectedMonth]);

    useEffect(() => {
        if (selectedDay) {
        }
    }, [selectedDay]);

    useEffect(() => {
        if (selectedOffice) {
        }
    }, [selectedOffice]);

    useEffect(() => {
        const [, , day] = selectedDate.split('-').map(Number);
        setSelectedDay(day); // Aggiorna selectedDay quando selectedDate cambia
        setSelectedMonth(selectedDate.slice(0, 7)); // Aggiorna selectedMonth quando selectedDate cambia
    }, [selectedDate]); // Ricarica i dati quando cambia il mese

    const goToToday = () => {
        const today = formatLocalDate(new Date());
        setSelectedDate(today);
    };

    return (
        <div className="container-fluid turni-page">
            {loading ? (
                <div className="text-center my-4">
                    <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            ) : (
                <React.Fragment>
                    <div className="row clearfix justify-content-center mb-10">
                        <div className="col-xl-6 col-12">
                            <div className="card proj-t-card">
                                <div className="card-body">
                                    <div className="d-flex justify-content-center mt-2 row">
                                        <div className="btn-group align-items-center mb-2 col-md-2 col-12">
                                            <button
                                                type="button"
                                                className={`btn py-1 mb-3 d-none d-sm-inline ${"ALL" === selectedOffice ? "btn-primary" : "btn-dark"}`}
                                                title="ALL"
                                                onClick={() => setSelectedOffice("ALL")}
                                            >
                                                ALL
                                            </button>
                                        </div>
                                        <div className="btn-group align-items-center mb-2 col-md col-12">
                                            {companyOffices.map((office, index) => (
                                                <button
                                                    key={index}
                                                    type="button"
                                                    className={`btn ml-2 py-1 mb-3 ${office.node.name === selectedOffice ? "btn-primary" : "btn-dark"}`}
                                                    title={office.node.name}
                                                    onClick={() => setSelectedOffice(office.node.name)}
                                                >
                                                    {office.node.name.slice(0, 3).toUpperCase()}
                                                </button>
                                            ))}
                                        </div>
                                        <div className="btn-group align-items-center mb-2 col-md col-12">

                                            <button
                                                type="button"
                                                className={`btn ml-2 py-1 mb-3 btn-light`}
                                                title='Vai a oggi'
                                                onClick={() => goToToday()}
                                            >
                                                <span className="material-symbols-outlined" style={{ fontSize: "20px" }}>
                                                    today
                                                </span>
                                            </button>
                                            <button
                                                type="button"
                                                className={`btn ml-2 py-1 mb-3 ${viewMode === "month" ? "btn-primary" : "btn-dark"}`}
                                                title='Visualizza mese'
                                                onClick={() => setViewMode("month")}
                                            >
                                                <span className="material-symbols-outlined" style={{ fontSize: "20px" }}>
                                                    calendar_month
                                                </span>
                                            </button>
                                            <button
                                                type="button"
                                                className={`btn ml-2 py-1 mb-3 ${viewMode === "week" ? "btn-primary" : "btn-dark"}`}
                                                title="Visualizza settimana"
                                                onClick={() => setViewMode("week")}
                                            >
                                                <span className="material-symbols-outlined" style={{ fontSize: "20px" }}>
                                                    calendar_view_week
                                                </span>
                                            </button>
                                        </div>
                                        <div className="btn-group align-items-center mb-2 col-md col-12">
                                            <button
                                                type="button"
                                                className="btn btn-secondary py-1 mb-3"
                                                title='Reset filtri'
                                                onClick={() => {
                                                    setViewMode("week");
                                                    goToToday();
                                                }}
                                            >
                                                <span className="material-symbols-outlined" style={{ fontSize: "20px" }}>
                                                    replay
                                                </span>
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-primary ml-2 py-1 mb-3"
                                                title="Ricarica turni"
                                                onClick={() => {
                                                    fetchCompanyOffices();
                                                    fetchShiftUsers();
                                                    fetchShiftTypes();
                                                    fetchShifts();
                                                    fetchClosures();
                                                }}
                                            >
                                                <span className="material-symbols-outlined" style={{ fontSize: "20px" }}>
                                                    refresh
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* TABELLA TURNI */}
                    {selectedOffice ? (
                        <div className="row clearfix justify-content-center mb-10">
                            <div className="col-lg-12">
                                <div className="card proj-t-card" style={{ overflow: "visible" }}>
                                    <div className="card-body bg-light py-0" style={{ overflow: "visible" }}>
                                        <div className="row my-1" style={{ position: "sticky", top: 104, zIndex: 10 }}>
                                            {/* PRIMA COLONNA-PRIMA RIGA */}
                                            <div className="col-2 col-md-1 text-center p-1 rounded shiftCell d-flex flex-column justify-content-center align-items-center"></div>

                                            {/* COLONNE UTENTI-PRIMA RIGA */}
                                            {shiftUsers
                                                .filter(shiftUser => shiftUser.node.CompanyOffice[0]?.name === selectedOffice || selectedOffice === "ALL")
                                                .map((shiftUser, index) => (
                                                    <div key={index} className="col text-center p-1 shiftCell">
                                                        <div className="rounded-bottom w-100 bg-white p-1">
                                                            <img src={`${globals.IMAGE_PATH.GENERIC}${shiftUser.node.User[0].avatar.fullpath}`} className="rounded rounded-circle mx-auto border border-white" height={30} />
                                                            <div className="d-md-none w-100"></div>
                                                            <small className="m-0 font-weight-bold d-inline d-sm-none">{shiftUser.node.User[0].username.slice(-3)}</small>
                                                            <h6 className="ml-2 font-weight-bold d-none d-sm-inline">{shiftUser.node.User[0].username.slice(-3)}</h6>
                                                        </div>
                                                    </div>
                                                ))}

                                            {/* ULTIMA COLONNA-PRIMA RIGA */}
                                            <div className="col-1 text-center p-1 rounded shiftCell d-flex flex-column justify-content-center align-items-center"></div>
                                        </div>
                                        {days && (
                                            days.map((day) => (
                                                <div key={day.date} className="row my-1 rounded">

                                                    {/* PRIMA COLONNA-GIORNO */}
                                                    <div className="col-2 col-md-1 text-center p-0 rounded shiftCell d-flex flex-column justify-content-center align-items-center bg-light ">
                                                        <div className={`row rounded w-100 ${selectedDay === day.day ? 'bg-primary text-white' : 'bg-dark text-white'} ${closures.includes(day.date) ? 'bg-red text-white' : ''}`} onClick={() => handleClosure(day)} >
                                                            <div className="col-12 m-0 p-0 cursor-pointer font-weight-bold">
                                                                <h4 className="m-0" style={{ maxWidth: '100%' }}>{day.day}</h4>
                                                            </div>
                                                            <div className="col-12 m-0 p-0 cursor-pointer font-weight-bold">
                                                                <h6 className="m-0 mb-1" style={{ maxWidth: '100%' }}>{day.dayName.toUpperCase().slice(0, 3)}</h6>
                                                                {/* <small className="m-0 text-truncate" style={{ maxWidth: '100%' }}>{day.day + "/" + (month + 1)}</small> */}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* COLONNE TURNI */}
                                                    {shiftUsers
                                                        .filter(shiftUser => shiftUser.node.CompanyOffice[0]?.name === selectedOffice || selectedOffice === "ALL")
                                                        .map((shiftUser, index) => (
                                                            <div className="col text-center shiftCell" key={index}>
                                                                <div className="row px-1">
                                                                    {(() => {
                                                                        var shiftColor = "";
                                                                        var shiftIcon = "";

                                                                        if (closures.includes(day.date)) {
                                                                            shiftColor = "bg-white text-red";
                                                                            shiftIcon = "blinds_closed";

                                                                            return (
                                                                                <div className={`col-12 p-1 mt-1 mb-0 shiftCell rounded-top ${shiftColor}`}>
                                                                                    <span className={`material-symbols-outlined shiftIcon`}>
                                                                                        {shiftIcon}
                                                                                    </span>
                                                                                </div>
                                                                            );
                                                                        } else {
                                                                            shiftColor = "bg-white";
                                                                            shiftIcon = "work";
                                                                            const matchingShift = shifts.find(shift => shift.node.User[0].id === shiftUser.node.User[0].id &&
                                                                                shift.node.timestamp === getShiftTimestamp(day.date, "M"));
                                                                            if (matchingShift) {
                                                                                shiftColor = matchingShift.node.ShiftType[0].color;
                                                                                shiftIcon = matchingShift.node.ShiftType[0].icon;
                                                                            } else {
                                                                                shiftColor = "bg-white";
                                                                                shiftIcon = "work";
                                                                            }
                                                                            return (
                                                                                <div className={`col-12 p-1 mt-1 mb-0 shiftCell cursor-pointer rounded-top ${shiftColor}`}
                                                                                    {...((((shiftIcon === "work" && shiftColor.includes("bg-white")) || shiftIcon === "flights_and_hotels") && props.userDetails.role <= 3 && props.userDetails.id === shiftUser.node.User[0].id) || props.userDetails.role <= 1 ?
                                                                                        { "data-toggle": "modal", "data-target": "#modalShiftEdit", onClick: () => handleOpenShiftModal(getShiftTimestamp(day.date, "M"), shiftUser.node.User[0].id, matchingShift?.node.id || null) } : { onClick: () => showWarningToast("Non hai i permessi per modificare un turno già assegnato o di qualcun altro.") })}>
                                                                                    <span className={`material-symbols-outlined shiftIcon`}>
                                                                                        {shiftIcon}
                                                                                    </span>
                                                                                </div>
                                                                            );
                                                                        }
                                                                    })()}


                                                                    {(() => {
                                                                        var shiftColor = "bg-white";
                                                                        var shiftIcon = "work";

                                                                        if (closures.includes(day.date)) {
                                                                            shiftColor = "bg-white text-red";
                                                                            shiftIcon = "blinds_closed";

                                                                            return (
                                                                                <div className={`col-12 p-1 mt-0 mb-1 shiftCell rounded-top ${shiftColor}`}>
                                                                                    <span className={`material-symbols-outlined shiftIcon`}>
                                                                                        {shiftIcon}
                                                                                    </span>
                                                                                </div>
                                                                            );
                                                                        } else {
                                                                            shiftColor = "bg-white";
                                                                            shiftIcon = "work";
                                                                            const matchingShift = shifts.find(shift => shift.node.User[0].id === shiftUser.node.User[0].id &&
                                                                                shift.node.timestamp === getShiftTimestamp(day.date, "P"));
                                                                            if (matchingShift) {
                                                                                shiftColor = matchingShift.node.ShiftType[0].color;
                                                                                shiftIcon = matchingShift.node.ShiftType[0].icon;
                                                                            } else {
                                                                                shiftColor = "bg-white";
                                                                                shiftIcon = "work";
                                                                            }
                                                                            return (
                                                                                <div className={`col-12 p-1 mt-0 mb-1 shiftCell cursor-pointer rounded-bottom ${shiftColor}`}
                                                                                    {...((((shiftIcon === "work" && shiftColor.includes("bg-white")) || shiftIcon === "flights_and_hotels") && props.userDetails.role <= 3 && props.userDetails.id === shiftUser.node.User[0].id) || props.userDetails.role <= 1 ?
                                                                                        { "data-toggle": "modal", "data-target": "#modalShiftEdit", onClick: () => handleOpenShiftModal(getShiftTimestamp(day.date, "P"), shiftUser.node.User[0].id, matchingShift?.node.id || null) } : { onClick: () => showWarningToast("Non hai i permessi per modificare un turno già assegnato o di qualcun altro.") })}>
                                                                                    <span className={`material-symbols-outlined shiftIcon`}>
                                                                                        {shiftIcon}
                                                                                    </span>
                                                                                </div>
                                                                            );
                                                                        }
                                                                    })()}
                                                                </div>
                                                            </div>
                                                        ))}


                                                    {/* ULTIMA COLONNA-PRESENZE */}
                                                    <div className="col-1 text-center p-0 rounded shiftCell d-flex flex-column justify-content-center align-items-center bg-light ">
                                                        <div className="row rounded bg-white w-100">
                                                            <div className="col-12 m-0 p-0 cursor-pointer font-weight-bold">
                                                                {(() => {
                                                                    if (closures.includes(day.date)) {
                                                                        return "0";
                                                                    }
                                                                    const shiftUsersSelectedOffice = shiftUsers.filter(user => user.node.CompanyOffice[0].name === selectedOffice || selectedOffice === "ALL");
                                                                    const shiftsFiltered = shifts.filter(shift => shift.node.ShiftType[0].icon !== "work" && shift.node.timestamp === getShiftTimestamp(day.date, "M") && shiftUsersSelectedOffice.find(user => user.node.User[0].id === shift.node.User[0].id));
                                                                    return shiftUsersSelectedOffice.length - shiftsFiltered.length;
                                                                })()}
                                                            </div>
                                                            <div className="col-12 m-0 p-0 cursor-pointer font-weight-bold">
                                                                {(() => {
                                                                    if (closures.includes(day.date)) {
                                                                        return "0";
                                                                    }
                                                                    const shiftUsersSelectedOffice = shiftUsers.filter(user => user.node.CompanyOffice[0].name === selectedOffice || selectedOffice === "ALL");
                                                                    const shiftsFiltered = shifts.filter(shift => shift.node.ShiftType[0].icon !== "work" && shift.node.timestamp === getShiftTimestamp(day.date, "P") && shiftUsersSelectedOffice.find(user => user.node.User[0].id === shift.node.User[0].id));
                                                                    return shiftUsersSelectedOffice.length - shiftsFiltered.length;
                                                                })()}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : ("Seleziona un punto vendita per visualizzare i turni")}
                </React.Fragment>
            )}

            {/* MODAL SHIFT EDIT */}
            <div className="modal fade" id="modalShiftEdit" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Modifica turno</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                {shiftTypes.map((shiftType, index) => (
                                    props.userDetails.role <= shiftType.node.permission && (
                                        <div key={index} className={`col-4 text-center p-2`}>
                                            <button className={`btn mb-1 w-100 shiftButton truncate ${shiftType.node.color}`}
                                                onClick={() => {
                                                    setShiftType(shiftType.node.id);
                                                }}>

                                                <span className={`material-symbols-outlined`}>
                                                    {shiftType.node.icon || "work"}
                                                </span><br />
                                                {shiftType.node.name}
                                            </button>

                                        </div>
                                    )
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <FooterBar
                footerButton={
                    <React.Fragment>
                        {props.userDetails && props.userDetails.role <= 1 && (
                            <FooterButton icon="download_for_offline" title="Esporta ore" action={() => { showInfoToast("Disponibile nel prossimo aggiornamento"); }} />
                        )}
                    </React.Fragment>
                }
                footerIcon={"work_history"}
                footerTitle={"Turni"}
                footerPlugin={<Calendar selectedDate={selectedDate} setSelectedDate={setSelectedDate} />}
            />
        </div>
    );
};
export default Turni;